export default __webpack_public_path__ + "static/media/NIAS0580.34I-40716_-25079_0.329fcdbe.jpg";